import React from 'react'

import { Text } from '@interco/inter-toranja'
import {
  TextType,
  TextSize,
  TextWeight,
} from '@interco/inter-toranja/dist/components/Atoms/Text/types'

import type { ComponentData } from '../interfaces'
import * as S from './styles'

interface HeaderProps
  extends Pick<ComponentData, 'titleHeader' | 'descriptionHeader' | 'titleStyle' | 'textSize'> {}

export const Header: React.FC<HeaderProps> = ({
  titleHeader,
  descriptionHeader,
  titleStyle,
  textSize,
}) => (
  <S.ContainerTitleText
    style={{
      marginTop: titleStyle?.marginTop ?? '0px',
      marginBottom: titleStyle?.marginBottom ?? '0px',
    }}
  >
    <Text
      textType={TextType.Title}
      textSize={textSize ?? TextSize.Large}
      textWeight={TextWeight.Bold}
      as="h1"
    >
      {titleHeader}
    </Text>
    <Text
      textType={TextType.Body}
      textSize={TextSize.Medium}
      textWeight={TextWeight.Regular}
      colorVariant="secondary"
      as="span"
    >
      {descriptionHeader}
    </Text>
  </S.ContainerTitleText>
)
